<template>
    <div class="load-assignment">
        <div class="loader"></div>
        <span>Wacht even, we laden nu de quiz voor je ;-)</span>
    </div>
</template>

<script>
import be from '../services/Backend';

//components
import TopContainer from './TopContainer.vue';

export default {
    'components': {TopContainer},
    'data': () =>
    {
        return { 
        }
    },
    'methods': {
        onCourseSelected(course) {
            be.MIA.setActiveCourse(course);
            be.MIA.getCourse(course.code)
                .done((data) => {
                    console.log('course status', data);
                    if(course.code == "mkbidee_course") {
                        this.$router.push({ name: 'assignmentgrid', params: {  } });
                    } else {
                        this.$router.push({ name: 'assignment', params: { code: data.resourceGroups[0].assignments[0].code } });
                    }
                    
                })
                .catch(() => {
                })
        },
    },
    mounted() {
        be.MIA.getMemberships()
            .done((data) => {
                console.log('membership data:', data, data[0]);
                
                let assessment = data.find(x => x.code == "mkbidee");
                let cursus     = data.find(x => x.code == "mkbidee_course");

                console.log('courses', assessment, cursus);

                if (cursus) {
                    this.onCourseSelected(cursus);
                } else if (assessment) {
                    this.onCourseSelected(assessment);
                } else {
                    this.onCourseSelected(data[0]);
                }
            })
            .catch(() => {
            });
    }
}
</script>